// Factory for a parquet-query helper bound to a sub-directory of src/db.
// Usage:
//   const queryParquet = makeParquetQuerier("Color Trails");
//   const rows = await queryParquet("ct1.parquet");
export function makeParquetQuerier(subdir) {
  return async function queryParquet(filename) {
    const result = await window.electronAPI.queryParquet(`${subdir}/${filename}`);
    if (!result.success) throw new Error(result.error);
    return result.rows;
  };
}
